"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@lingui/react");

var _react2 = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _PriorityBadge = require("../PriorityBadge");

var _analysis = require("../../../../context/analysis");

var _GroupHeading = require("../GroupHeading.styles");

const PriorityGroupHeading = ({
  instance,
  insightsCount,
  equipsCount,
  unassociatedEquipsCount,
  insightsCountToday
}) => {
  if (!instance || instance.priority === undefined) return null;
  const [{
    viewMode
  }] = (0, _analysis.useAnalysis)();
  const headingText = instance.priority === 0 ? 'Unprioritised' : viewMode === 'insights' ? 'Prioritised' : `Priority ${instance.priority}`;
  return /*#__PURE__*/_react2.default.createElement(_GroupHeading.Bar, null, /*#__PURE__*/_react2.default.createElement(_GroupHeading.Left, null, /*#__PURE__*/_react2.default.createElement(_GroupHeading.IconWrapper, null, /*#__PURE__*/_react2.default.createElement(_PriorityBadge.PriorityBadge, {
    priority: instance.priority
  })), /*#__PURE__*/_react2.default.createElement(_blocks.BodyLarge, {
    as: "div"
  }, headingText, ' ', /*#__PURE__*/_react2.default.createElement(_GroupHeading.SubduedBodyLarge, {
    as: "span"
  }, "(", insightsCount, ")"), /*#__PURE__*/_react2.default.createElement(_GroupHeading.TodayCountWrapper, null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "{equipsCount, plural, one {{unassociatedEquipsCount} of {equipsCount} Equip Unassociated} other {{unassociatedEquipsCount} of {equipsCount} Equips Unassociated}}",
    values: {
      equipsCount: equipsCount,
      unassociatedEquipsCount: unassociatedEquipsCount
    }
  })))), /*#__PURE__*/_react2.default.createElement(_GroupHeading.Right, null, insightsCountToday > 0 && /*#__PURE__*/_react2.default.createElement(_blocks.Badge, null, insightsCountToday, " new")));
};

var _default = PriorityGroupHeading;
exports.default = _default;
module.exports = exports.default;